module.exports = __webpack_public_path__ + "img/raketa_dolevanahoru.31df4655.png";